import { Backpack, CloudRain, Route, Shield, Tent } from '@/ui/icons'

interface SuggestionChip {
  icon: typeof Tent
  label: string
  message: string
}

const TRIP_SUGGESTIONS: SuggestionChip[] = [
  {
    icon: Tent,
    label: 'Find dispersed campsites',
    message: 'Find dispersed camping spots near my trip campsites',
  },
  {
    icon: Backpack,
    label: 'Gear checklist',
    message: 'What gear should I bring for this trip?',
  },
  {
    icon: CloudRain,
    label: 'Weather risks',
    message: 'Are there any weather risks I should plan around for this trip?',
  },
  {
    icon: Route,
    label: 'Route feedback',
    message: 'Take a look at my route and let me know if anything stands out',
  },
]

const GENERAL_SUGGESTIONS: SuggestionChip[] = [
  {
    icon: Tent,
    label: 'Find dispersed camping',
    message: 'Help me find dispersed camping spots near a location',
  },
  {
    icon: Backpack,
    label: 'Gear checklist',
    message: 'What gear do I need for backcountry overlanding?',
  },
  {
    icon: Shield,
    label: 'Safety planning',
    message: 'What should I consider for safety on a remote trip?',
  },
]

interface RangerSuggestionsProps {
  tripId?: string
  onSelect: (message: string) => void
  disabled?: boolean
}

export function RangerSuggestions({ tripId, onSelect, disabled }: RangerSuggestionsProps) {
  const suggestions = tripId ? TRIP_SUGGESTIONS : GENERAL_SUGGESTIONS

  return (
    <div className="flex w-full flex-wrap justify-center gap-1.5">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion.label}
          type="button"
          onClick={() => onSelect(suggestion.message)}
          disabled={disabled}
          className="inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-2.5 py-1.5 text-xs font-medium text-foreground transition-colors hover:border-adventure-300 hover:bg-adventure-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-adventure-500 disabled:cursor-not-allowed disabled:opacity-50 dark:hover:bg-adventure-950/20"
        >
          <suggestion.icon className="h-3.5 w-3.5 shrink-0 text-adventure-600" aria-hidden />
          {suggestion.label}
        </button>
      ))}
    </div>
  )
}
